<template>
  <el-dialog :title="form.id?'编辑':'新建'" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="100px">
      <el-form-item label="技术老师" prop="teacherId" class="width100">
        <el-select v-model="form.teacherId" filterable placeholder="请选择技术老师" clearable size="small" :filter-method="technicianFilter" @blur="getTechnicianList()">
          <el-option :label="`${item.realName}（${item.levelName}）${item.mobile}`" :value="item.id" v-for="item in technicianList" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="宣传图" prop="promotionImg" class="width100">
        <imageUpload v-model="form.promotionImg" width="36" height="36" />
      </el-form-item>
      <el-form-item label="排序号" prop="orderNo" class="width100">
        <el-input v-model="form.orderNo" placeholder="请输入排序号" />
      </el-form-item>
      <el-form-item label="状态" prop="state" class="width100">
        <el-radio-group v-model="form.state">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import templateTeacherApi from '@/api/marketing/templateTeacher'
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ImageUpload from "@/components/ImageUpload";
import technicianInfoApi from '@/api/technical/technicianInfo'
function initFormBean() {
  const formBean = {
    teacherId: null,
    promotionImg: null,
    orderNo: null,
    state: 1
  }
  return formBean
}

export default {
  props: ['menuOptions'],
  components: { ImageUpload, Treeselect },
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        teacherId: [{ required: true, message: '请选择技术老师', trigger: 'change' }],
        promotionImg: [{ required: true, message: '请上传宣传图', trigger: 'change' }],
        orderNo: [{ required: true, message: '请输入排序号', trigger: 'blur' }, { pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],
        state: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      isRepSub: false,
      technicianList: [],
    }
  },
  created() {
    this.getTechnicianList()
  },
  methods: {
    technicianFilter(e) {
      this.getTechnicianList(e)
    },
    getTechnicianList(e) {
      let obj = {status: 10, pageNo: 1,pageSize: 100}
      obj.realName = e
      technicianInfoApi.fetchList(obj).then(({data}) => {
        this.technicianList = data.list
      })
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      let params = JSON.parse(JSON.stringify(this.form))
      params.orderNo = parseInt(params.orderNo) || 0
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          if (this.form.id > 0) {
            templateTeacherApi.update(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            templateTeacherApi.create(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select{
  width: 100%;
}
</style>
